export default "__VITE_ASSET__BDcF1mD2__"